export const environment = {
  environment: 'production',
  storageKeys: {
    token: 'TOKEN',
    user: 'USER',
  },
  features: {
    symplMigration: true,
    discounts: true,
    agodaContentApi: false,
    bdcContentApi: true,
    spreedlyWhitelist: {
      1549238313.7276: ['mercado_pago'],
      1568144220.3296: ['mercado_pago'],
    },
    airbnb: {
      bookingPreferences: true,
      bookingSettings: true,
      priceSettings: true,
      taxSettings: false,
    },
    losModality: true,
    signatureStandalone: false,
    compliance: true,
  },
  plans: {
    rategenieStandalone: 'rategenie_v3',
    signatureStandalone: 'signature_v3',
    tokeetStandalone: 'tokeet_v5',
    tokeetStandaloneYearly: 'tokeet_yr_v5',
  },
  prefix: 'tv3',
  cacheInterceptorLog: false,
  production: true,
  showSecurityDeposits: true,
  symplMaxRentals: 5,
  languages: [
    { name: 'English', value: 'en' },
    { name: 'German', value: 'de' },
    { name: 'Spanish', value: 'es' },
    { name: 'French', value: 'fr' },
    { name: 'Greek', value: 'el' },
    { name: 'Croatian', value: 'hr' },
    { name: 'Indonesian', value: 'id' },
    { name: 'Italian', value: 'it' },
    { name: 'Lithuanian', value: 'lt' },
    { name: 'Portuguese', value: 'pt' },
    { name: 'Serbian', value: 'sr' },
  ],
  defaultWhatsappSenderName: 'Short Stay Messaging Service',
  topDomain: '.tokeetmail.com',
  apiUrl: 'https://api.tokeet.com',
  signatureApiUrl: 'https://api.usesignature.com',
  webreadyApiUrl: 'https://api.usewebready.com',
  papiApiUrl: 'https://papi.tokeet.com',
  sslAPIUrl: 'https://ssl.tokeet.com',
  checklistUrl: 'https://app.usechecklist.com/',
  rategenieApiUrl: 'https://api.rategenie.io/v1',
  signatureUrl: 'https://app.usesignature.com/',
  automataUrl: 'https://app.useautomata.com/',
  rategenieUrl: 'https://app.rategenie.io/',
  appStoreUrl: 'https://store.tokeet.com/',
  reportsUrl: 'https://app.usemargins.com/',
  symplUrl: 'https://app.sympl.cm/',
  ownerCenterUrl: 'https://app.ownercenter.net/',
  webreadyUrl: 'https://app.usewebready.com/',
  powerReportingUrl: 'https://login.powerreporting.net',
  aiAPIUrl: 'https://api.aireply.io',
  legacyTv3Url: 'https://app.tokeet.com',
  perfume: true,
  config: {
    amplitudeApiKey: 'e3d4f2ded3f69524c281ae329adbd6e4',
    websiteDomains: ['.shortlettings.net', '.mylettings.me', '.housesquat.com'],
    bookingEngineDomains: ['.booksafely.com', '.securelettings.net', '.trustbookers.com'],
    guestPortalDomains: ['.myrental.guide'],
    sentryDns: 'https://765b52100ae14668b2a4e595da6d043a@sentry.io/1402194',
    apiBaseUrl: 'https://api.tokeet.com/',
    apiMailBaseUrl: 'https://api.tokeet.com/web',
    CMBaseUrl: 'https://cm.tokeet.com',
    invoiceBaseUrl: 'https://invoices.advance.cm/',
    guestPortalUrl: 'https://guest.tokeet.com/',
    registerUrl: 'https://register.tokeet.com/',
    helpUrl: 'http://helpdocs.tokeet.com/',
    oauthUrl: 'https://oauth.tokeet.com',
    calendarShareUrl: 'https://share.tokeet.com/calendar/',
    iCalEndpoint: 'https://calendars.tokeet.com',
    googleMapKey: 'AIzaSyB1Y6gtva7YVwWejE4aEm3a7meDbq1GQlc',
    defaultSMSPhoneNumber: '+18622474223',

    mailChimpClientId: '836193949496',
    mailChimpRedirectUrl: 'https://api.tokeet.com/oauth/mailchimp',
    mailChimpOAuthUrl: 'https://login.mailchimp.com/oauth2/authorize?response_type=code',

    slackClientId: '25867822561.258713700369',
    stripe_publishable_key: 'pk_live_uTx1fM9ZE6wEjEW6t2Cx9caK',
    slackRedirectUrl: 'https://api.tokeet.com/oauth/slack',
    slackOAuthUrl: 'https://slack.com/oauth/v2/authorize?response_type=code',

    dropboxClientId: 'pmc9hxua63dj1sf',
    dropboxRedirectUrl: 'https://api.tokeet.com/oauth/dropbox',
    dropboxOAuthUrl: 'https://www.dropbox.com/oauth2/authorize?response_type=code',

    stripeClientId: 'ca_7WEyTGm9SP0EKyrk7vihMnGQJDxC063w',
    stripeRedirectUrl: 'https://api.tokeet.com/oauth/stripe',
    stripeOAuthUrl: 'https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write',
    paypalUrl: 'https://www.paypal.com',

    cloudinaryURL: 'https://api.cloudinary.com/v1_1',
    cloudinaryCloudName: 'tokeet',
    cloudinaryUploadPreset: 'qpzoegqz',

    topDomain: '.tokeetmail.com',

    worldpayDeveloperId: '12345678',
    worldpayVersion: '1.0',

    dataFeedURL: 'https://datafeed.tokeet.com',

    airbnbClientId: '1r8sp56opjvvsc23k1vq4z5k6',
    airbnbRedirectUrl: 'https://api.tokeet.com/oauth/abbv2/',
    airbnbOAuthUrl: 'https://www.airbnb.com/oauth2/auth?scope=vr,messages_read,messages_write&',

    intercomAppId: 'ziijopdr',
    wootricToken: 'NPS-a11df413',

    tokeetAIContractId: '853065e0-d4c2-49a5-b47f-e641c7c94ae3',
    tokeetAIContractSignerRole: 'Contact',

    smartDevicesContractId: 'd943cfc2-9181-4f51-b290-39470db9380a',
    smartDevicesContractSignerRole: 'Contact',
    seamPublishableKey: 'seam_pk1dYjXIT_6PP6Y77svUU7adoz2zWMPU/h',

    quickBooksClientId: 'ABQP7rn8fAXoGGO0DLUrUiOZfYTi78MrkdsCe9gaoGOu3KCpbK',
    quickBooksRedirectUrl: 'https://api.tokeet.com/quickbooks/oauth/callback',
    quickBooksOAuthUrl:
      'https://appcenter.intuit.com/connect/oauth2?scope=com.intuit.quickbooks.accounting openid profile email&response_type=code',
  },
}
